import { Component, Inject, OnInit } from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose,
} from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { SubSink } from 'subsink';
import { AutoUnsubscribe } from '../../../core/auto-unsubscribe';
import { RequestProductDeleteDialogService } from './request-product-delete-dialog.service';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@AutoUnsubscribe()
@Component({
  selector: 'app-request-product-delete-dialog',
  templateUrl: './request-product-delete-dialog.component.html',
  styleUrls: ['./request-product-delete-dialog.component.scss'],
  providers: [RequestProductDeleteDialogService],
  standalone: true,
  imports: [
    CdkScrollable,
    MatDialogContent,
    MatDialogActions,
    MatButton,
    MatDialogClose,
    TranslateModule,
  ],
})
export class RequestProductDeleteDialogComponent implements OnInit {
  subs = new SubSink();

  constructor(
    @Inject(MAT_DIALOG_DATA)
    data: { requestId: number; productId?: number },
    private dialogRef: MatDialogRef<any>,
    private spinnerService: NgxSpinnerService,
    private requestProductDeleteDialogService: RequestProductDeleteDialogService
  ) {
    this.requestProductDeleteDialogService.key = data;
  }

  ngOnInit(): void {
    this.subs.sink = this.requestProductDeleteDialogService
      .loadProduct()
      .subscribe();
  }

  onConfirmClicked() {
    this.spinnerService.show();
    this.subs.sink = this.requestProductDeleteDialogService
      .removeProduct()
      .subscribe(s => {
        this.spinnerService.hide();
        this.dialogRef.close();
      });
  }
}
